import React from 'react'
import { connect } from 'react-redux'

export default connect(
	(state) => ({
		buttonText: state.signupForm.addOrEdit.values.buttonText.value,
		buttonTextColor: state.signupForm.addOrEdit.values.buttonTextColor.value,
		buttonBackgroundColor:
			state.signupForm.addOrEdit.values.buttonBackgroundColor.value,
		formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
		pagebreaks: state.customForm.addOrEdit.form.sections
			.map((id) => state.customForm.addOrEdit.sectionsByID[id])
			.filter((el) => el?.type === 'pagebreak'),
		pageSelected: state.customForm.addOrEdit.pageSelected,
	}),
	null,
)(
	({
		buttonText,
		buttonTextColor,
		buttonBackgroundColor,
		formTypeSelected,
		pagebreaks,
		pageSelected,
	}) => {
		const button = (
			<button
				style={{
					color: buttonTextColor,
					backgroundColor: buttonBackgroundColor,
					padding: 8,
					borderRadius: 8,
					border: 'none',
					marginTop: 8,
					width: '100%',
				}}
			>
				{buttonText}
			</button>
		)

		const paddedButton = <div style={{ padding: '0 20px' }}>{button}</div>

		if (formTypeSelected === 'custom') {
			if (pagebreaks.length && pageSelected !== pagebreaks.length) {
				return null
			}
			return paddedButton
		}

		return button

		// return formTypeSelected === 'custom'
		//   ? pagebreaks.length
		//     ? pageSelected === pagebreaks.length
		//       ? null
		//       : paddedButton
		//     : paddedButton
		//   : button
	},
)
